import React, { useMemo } from 'react';
import { PanelButton, PanelButtonDivider } from '.';
import EditSessionRender from '../../containers/EditSessionProvider/EditSessionRender';
import useT from '../../utils/Translations/useT';
import useHelpNoteTitle from '../../utils/Translations/useHelpNoteTitle';
const AddButton = ({ isSingle = false, isDisabled = false, className = '', title, tooltipTitle, onClick, dataCy, }) => {
    const t = useT();
    const divider = useMemo(() => (isSingle ? null : <PanelButtonDivider />), [
        isSingle,
    ]);
    const label = useMemo(() => title || t('Add'), [title, t]);
    const resolvedTooltipTitle = useHelpNoteTitle(label, tooltipTitle);
    const addButton = useMemo(() => (<>
        <PanelButton className={className} dataCy={dataCy} icon="plus3" isDisabled={isDisabled} title={label} tooltipTitle={resolvedTooltipTitle} onClick={onClick}/>
        {divider}
      </>), [
        label,
        divider,
        className,
        onClick,
        isDisabled,
        resolvedTooltipTitle,
        dataCy,
    ]);
    return <EditSessionRender>{addButton}</EditSessionRender>;
};
export default AddButton;
